import makeStyles from "@mui/styles/makeStyles"

const useDialogBoxStyles = makeStyles(() => {
return {
    
    dialogTitle: {
        background: "#002B49",
      },
      signupImage: {
        display: "flex",
        justifyContent: "space-around",
      },
      signupClose: {
        position: "absolute",
        top: 10,
        right: 10,
        color: "white",
        cursor: "pointer",
      },
      dialogContent: {
        background: "#002B49",
      },
}
});

export default useDialogBoxStyles;